import React from 'react';
import { animationData } from './loader_json';

export default class AnimatedLoader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isStopped: false,
            isPaused: false
        };
    }

    render() {
        // fadeIn animated
        const className = this.props.className ? this.props.className : 'game-loading-screen';
        return (
            <div
                className={className}
            >
                <img className={'zoomIn animated'} src={animationData[this.props.type]} alt={''} />
            </div>
        )
    }
}